export default __webpack_public_path__ + "static/media/barrierefreiheit.94ecefc2.svg";